/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Project_NameInputs */

const en_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a project name:`)
};

const fr_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nom de projet :`)
};

const de_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen Projektnamen ein:`)
};

const it_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per il progetto:`)
};

const ru_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите название проекта:`)
};

const es_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre de proyecto:`)
};

const zh_cn2_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入项目名称：`)
};

const ja_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト名を入力してください:`)
};

const hi_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया प्रोजेक्ट का नाम दर्ज करें:`)
};

const pt_pt2_enter_project_name = /** @type {(inputs: Enter_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira o nome do projeto:`)
};

/**
* | output |
* | --- |
* | "Please enter a project name:" |
*
* @param {Enter_Project_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enter_project_name = /** @type {((inputs?: Enter_Project_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Project_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enter_project_name(inputs)
	if (locale === "de") return de_enter_project_name(inputs)
	if (locale === "it") return it_enter_project_name(inputs)
	if (locale === "ru") return ru_enter_project_name(inputs)
	if (locale === "es") return es_enter_project_name(inputs)
	if (locale === "zh-CN") return zh_cn2_enter_project_name(inputs)
	if (locale === "ja") return ja_enter_project_name(inputs)
	if (locale === "hi") return hi_enter_project_name(inputs)
	if (locale === "pt-PT") return pt_pt2_enter_project_name(inputs)
	return en_enter_project_name(inputs)
});